import { render, staticRenderFns } from "./LumpSumPaymentsReport.vue?vue&type=template&id=8f244234&"
import script from "./LumpSumPaymentsReport.vue?vue&type=script&lang=ts&"
export * from "./LumpSumPaymentsReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports